import { Component } from '@angular/core';

@Component({
  selector: 'spinner',
  standalone: true,
  imports: [],
  template: `
    <div
      class="fixed top-0 right-0 z-100 w-[100vw] h-[100vh] bg-[var(--bg-modal)] flex items-center justify-center space-x-1"
    >
      <div class="loader">
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
      </div>
    </div>
  `,
  styleUrl: './spinner.component.scss',
})
export class SpinnerComponent {}
